import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Read one-time values another page passed in the route state (a success
 * message, a notice), then clear the state from history so a refresh or Back
 * doesn't show them again. Returns the values as they were on arrival.
 */
export default function useConsumeLocationState(keys) {
    const location = useLocation();
    const navigate = useNavigate();
    const [values] = useState(() =>
        Object.fromEntries(keys.map((key) => [key, location.state?.[key]]))
    );
    const hasAny = keys.some((key) => location.state?.[key]);

    useEffect(() => {
        if (hasAny) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [hasAny, location.pathname, navigate]);

    return values;
}
